import Feature from './Feature';
import { random } from '../../utils/strings';
const merge = require('lodash/merge');

function formStructure(form = null) {
    const newForm = {
        id: 'new' + random(8),
        name: '',
        is_draft: false,
        data: {
            description: '',
            orientation: 'portrait',
            pageSize: 'letter',
            thumbnail: '',
            pages: [],
            settings: {
                signatureLegend: false,
                paymentRequired: false,
                paymentCalculated: false,
                paymentAmount: '',
                paymentAmountCalculate: '',
                language: 'en',
            },
            attachments: [],
            featureGroups: {},
            featureFlags: {
                ADP: false
            },
            dataElements: []
        },
    };
    if (form) {
        merge(newForm, form);
        for (let i = 0; i < newForm.data.pages.length; i++) {
            newForm.data.pages[i] = pageStructure(newForm.data.pages[i]);
        }
        for (let i = 0; i < newForm.data.attachments.length; i++) {
            newForm.data.attachments[i] = attachmentStructure(newForm.data.attachments[i]);
        }
        for (let id in newForm.data.featureGroups) {
            newForm.data.featureGroups[id] = featureGroupStructure(newForm.data.featureGroups[id]);
        }
    } else {
        newForm.data.pages.push(pageStructure());
    }
    return newForm;
}

function pageStructure(page = null) {
    const newPage = {
        pageSize: null,
        orientation: null,
        pageWidth: null,
        pageHeight: null,
        bgMarginTop: 0,
        bgMarginBottom: 0,
        bgMarginLeft: 0,
        bgMarginRight: 0,
        backgroundImage: null,
        features: [],
        backgroundText: null,
        textOverlays: []
    };
    if (page) {
        merge(newPage, page);
        for (let i = 0; i < newPage.features.length; i++) {
            newPage.features[i] = Feature.build(newPage.features[i]);
        }
    }
    return newPage;
}

function attachmentStructure(attachment = null) {
    const newAttachment = {
        id: 'new' + random(8),
        name: 'Attachment',
        description: '',
        is_required: false,
        is_filler_attachment: true,
        files: []
    };
    if (attachment) {
        merge(newAttachment, attachment);
    }
    return newAttachment;
}

function featureGroupStructure(group = null) {
    const newGroup = { type: '' };
    if (group) merge(newGroup, group);
    if (newGroup.type === 'checkbox' && newGroup.multiple === undefined) {
        newGroup.multiple = false;
    }
    return newGroup;
}

export {
    formStructure,
    pageStructure,
    attachmentStructure,
    featureGroupStructure
};